import { Spinner, Button } from "react-bootstrap";

// NOTE - spinner is a little wonky because I'm trying not to have it modify the dimensions of the button when showing.
// NOTE - onClick action should (a) set the spinner, and (b) do the rest using afterRenderDelay to ensure that the rendering gets started before whatever actions you want to happen.
export function SpinnerButton(props) {
	let { spinning, spinnerStyle, children, style, disabled, spinnerPosition, ...passableProps } = props;
	style = style || {};
	spinnerPosition = spinnerPosition || "inside";
	style["position"] = "relative";
	spinnerStyle = spinnerStyle || {};

	return <>
		<Button style={style} disabled={disabled || spinning} {...passableProps}>
			{spinning && (spinnerPosition == "inside") && <Spinner style={{...{position: "absolute", top: "30%", left: "10%", backgroundColor: "transparent"}, ...spinnerStyle}} animation="border" size="sm" />}
			{children}
		</Button>
		{spinning && (spinnerPosition == "outside") && <Spinner style={spinnerStyle} animation="border" size="sm" className="ms-4" />}
	</>;
}